































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';

// --- Services ---
import AppService from '@/services/app';

// --- Models ---
import { Institution } from '@/models/Institution.model';

@Component
export default class SearchByTertiary extends Vue {

  // used by Searchbox
  search: string = '';

  // used by Searchbox
  userInput: string = '';

  // used by data table that changes the footer
  mobileBreakpoint: number = 799;  

  // used by loaders
  isLoading: boolean = false;

  institutionList: Institution[] = [];

  // used by Item Dialog for Viewing Institution Info
  showInfoDialog: boolean = false;
  title: string = '';
  clickedItem: Institution = {
    id: 0,
    name: '',
    qualificationDescription: '',
    //qualification: '', // vue-admin#80 Institutions - Update to use Qualification ID
  };

  get headers() {
    return [
      {
        text: 'Institution Name',
        value: 'name',
      },
      {
        text: 'Qualification Type',
        value: 'qualificationClassification',
      },
      {
        text: 'Qualification',
        value: 'qualificationDescription',
        //value: 'qualification', // vue-admin#80 Institutions - Update to use Qualification ID
      },
      {
        text: 'Website',
        value: 'website',
      },
      {
        text: 'Course length',
        value: 'courseLength',
      },
      {
        text: 'APS',
        value: 'aps',
      },
      {
        text: 'Faculty',
        value: 'faculty',
      },
      {
        sortable: false,
        text: '',
        value: 'action',
        align: 'end',
      },
    ];
  }

  getItemsPerPage(items: Institution[]) {
    let itemsPerPage: any[] = [];

    if (this.$vuetify.breakpoint.width > this.mobileBreakpoint) {
      // On larger viewport listing view
      if (items.length > 100) {
        itemsPerPage = [10, 25, 50, 100];
      } else {
        itemsPerPage = [10, 25, 50, { text: 'All', value: -1 }];
      }
    } else {
      // On the smaller viewport stacked view
      itemsPerPage = [5, 10, 25];
    }

    return { itemsPerPageOptions: itemsPerPage };
  }

  async getInstitutions() {
    try {
      //used to display the loading animation
      this.isLoading = true;

      const response = await AppService.getInstitutionsByTertiary({
        params: { searchedTerm: this.userInput },
      }); //this.selectedSubject.id

      if (response && response.data) {
        if (response.data.result && response.data.result === 'false') {
          this.institutionList = [];
        } else {
          this.institutionList = response.data;
        }
      } else {
        // response is undefined or has no data field - SHOULD NEVER HAPPEN!
        throw new Error('response: ' + JSON.stringify(response));
      }
    } catch (error) {
      if (error.response) {
        AppService.errorHandler(error.response.statusText);
      } else {
        AppService.errorHandler(
          this.$store.getters['app/messages'].couldNotConnect,
        );
      }
    } finally {
      this.isLoading = false;
    }
  }

  // #region Functions required for the Item Dialog for View
    launchShowInfoDialog(item: Institution) {
      this.clickedItem = Object.assign({}, item);

      this.title = this.clickedItem.qualificationDescription + ' at ' + this.clickedItem.name;
      //this.title = this.clickedItem.qualification + ' at ' + this.clickedItem.name; // vue-admin#80 Institutions - Update to use Qualification ID

      this.showInfoDialog = true;
    }

    getSubjects() {
      return (this.clickedItem.compulsorySubjects ? '<span style="font-weight: 600">Compulsory:</span> ' + this.clickedItem.compulsorySubjects + '<br/>' : '')
        + (this.clickedItem.option1 ? '<span style="font-weight: 600">Choose 1:</span> ' + this.clickedItem.option1 + '<br/>' : '')
        + (this.clickedItem.option2 ? '<span style="font-weight: 600">Choose 2:</span> ' + this.clickedItem.option2 + '<br/>' : '')
        + (this.clickedItem.option3 ? '<span style="font-weight: 600">Choose 3:</span> ' + this.clickedItem.option3 + '<br/>' : '')
        + (this.clickedItem.option4 ? '<span style="font-weight: 600">Choose 4:</span> ' + this.clickedItem.option4 + '<br/>' : '');
    }
  // #endregion
}
